import React, { Component } from 'react';
import { doubleNumber, trans } from '../../../helpers';
import DatePicker, { registerLocale } from 'react-datepicker';
import hy from 'date-fns/locale/hy';
import ru from 'date-fns/locale/ru';
import { localStorageGetItem } from '../../../storage';
import base64 from 'base-64';
import utf8 from 'utf8';
import ApiManager from '../../../apiManager';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';
import config from '../../../baseConfig/index';
import Select from 'react-select';

class B2bFinancialReports extends Component {

    constructor( props ){
        super( props );

        this.startDate = new Date();

        this.state = {
            startMonth: new Date( this.startDate.setDate(this.startDate.getDate()) ),
            endMonth: new Date(),
            'file-type-form': 'pdf',
            'choose-form': 'getInvoices',
            'ban-field': '',
            buttonDisabled: false,
            zoomPoint: 1,
            banCount: 0,
            banLimit: 20,
            hasBanItem: '',
            hasBanLimitAbove: false,
            toggleAllBans: false,
            profileData: '',
            curatorBanCount: 0,
            curatorBanCountError: false,
            curatorBanNotOwnError: false,
            formResponse: '',
            resultBans: {},
            selectedOption: null,
            // Protocol
            startMonthProtocol: new Date( this.startDate.setMonth(this.startDate.getMonth()-1) ),
            buttonDisabledProtocol: false,
            formResponseProtocol: '',
            resultBansProtocol: {},
            'ban-field-protocol': '',
            curatorBanCountProtocol: 0,
            curatorBanCountErrorProtocol: false,
            curatorBanNotOwnErrorProtocol: false,
            hasBanLimitAboveProtocol: false,
            'file-type-form-protocol': 'pdf',
            hasBanItemProtocol: '',
            banCountProtocol: 0,
            banLimitProtocol: 20,
            toggleAllBansProtocol: false,
            zoomPointProtocol: 1
        };

        // Component props
        this.componentIsMounted = true;
        this.startDatepickerRef = React.createRef();
        this.startDatepickerRef2 = React.createRef();
        this.banCollection = [];
        this.banCollection2 = [];

        // Bind own methods
        this.handleChange = this.handleChange.bind( this );
        this.sendRequestSuccess = this.sendRequestSuccess.bind( this );
        this.handleSelectChange = this.handleSelectChange.bind( this );
        this.sendRequest = this.sendRequest.bind( this );
        this.sendRequestProtocol = this.sendRequestProtocol.bind( this );
        this.sendRequestSuccessProtocol = this.sendRequestSuccessProtocol.bind( this );

    }

    componentDidMount() {

        const { curator, profileData } = this.props;

        if ( curator === 'curator' && profileData !== '' && profileData.status === 'OK' ) {
            this.setState({
                profileData,
                curatorBanCount: profileData.data.bans.length,
                curatorBanCountProtocol: profileData.data.bans.length
            });
        }

        window.onbeforeprint = () => {
            if ( document.getElementsByClassName('main-wrapper__report-result-table').length ) {
                document.getElementById('root').className = 'print-table';
            }
        };

        window.onafterprint = () => {
            if ( document.getElementsByClassName('main-wrapper__report-result-table').length ) {
                document.getElementById('root').className = '';
            }
        };

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {

        const { curator, profileData } = nextProps;

        if ( curator === 'curator' && profileData !== '' && profileData.status === 'OK' ) {
            nextState.profileData = profileData;
            nextState.curatorBanCount = profileData.data.bans.length;
            nextState.curatorBanCountProtocol = profileData.data.bans.length;
        }

        return nextState;

    }

    componentWillUnmount(){

        this.componentIsMounted = false;
        this.startDatepickerRef = null;

    }

    options(){

        return [
            { value: 1, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_1' ) },
            { value: 2, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_2' ) },
            { value: 3, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_3' ) },
            { value: 4, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_4' ) },
            { value: 5, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_5' ) },
            { value: 6, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_6' ) },
            { value: 7, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_7' ) },
            { value: 8, label: trans( this.props.b2bTrans, 'b2b.financial_reports.option_8' ) },
        ];

    }

    handleSelectChange( newState ){

        this.setState({
            selectedOption: newState
        });

    }

    handleChange({ target: { name, value, dataset } }){

        if ( dataset.hasOwnProperty('filter') ) {

            if ( dataset.filter === 'numberOnly' ) {
                value = value.replace(/[^\d]/g, '');
            }

        }

        this.setState({
            [name]: value
        });

    }

    checkBySeconds( d ){

        return Math.floor( d.getTime() / 1000 );

    }

    datepickerSetter( date, startMonth, endMonth ){

        if ( date !== null ) {

            const newDate = new Date(date);

            if ( endMonth ) {
                startMonth = date;
                endMonth = ( this.checkBySeconds( date ) > this.checkBySeconds( this.state.endMonth ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.endMonth;
            } else if ( startMonth ) {
                endMonth = date;
                startMonth = ( this.checkBySeconds( date ) < this.checkBySeconds( this.state.startMonth ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.startMonth;
            }

        } else {
            startMonth = new Date();
            endMonth = new Date();
        }

        this.setState({
            startMonth,
            endMonth
        });

    }

    datepickerSetterProtocol( date, startMonthProtocol ){

        if ( date !== null ) {

            const newDate = new Date(date);
            startMonthProtocol = ( this.checkBySeconds( date ) < this.checkBySeconds( this.state.startMonth ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.startMonth;

        } else {
            startMonthProtocol = new Date();
        }

        this.setState({
            startMonthProtocol
        });

    }

    setZoomPoint( zoomPoint, isProtocol ){

        zoomPoint = ( zoomPoint < 0.2 ) ? 0.2 : zoomPoint;

        if ( isProtocol ) {
            this.setState({
                zoomPointProtocol: zoomPoint
            });
        } else {
            this.setState({
                zoomPoint: zoomPoint
            });
        }

    }

    resultTable( isProtocol ){

        let result = '',
            formResponse = this.state.formResponse;

        if ( isProtocol ) {
            formResponse = this.state.formResponseProtocol;
        }

        if ( formResponse !== '' && formResponse.hasOwnProperty('result') && formResponse.result.status === 'OK' && formResponse.result.count === 1 ) {

            let table = null;

            if ( formResponse.hasOwnProperty('html') && formResponse.html !== '' ) {

                table = (
                    <div className="main-wrapper__report-result-content pr">

                        <div className="main-wrapper__report-result-table-box scroller-block">
                            <div
                                className="main-wrapper__report-result-table"
                                style={{ transform: 'scale(' + ( isProtocol ? this.state.zoomPointProtocol : this.state.zoomPoint ) + ')' }}
                                dangerouslySetInnerHTML={{__html: utf8.decode(base64.decode( formResponse.html ))}}
                            />
                        </div>

                        <div className="main-wrapper__report-result-zoom-box pa">
                            <button
                                className="btn-zoom btn-zoom--plus pr"
                                type="button"
                                onClick={() => {
                                    let zoomPoint = this.state.zoomPoint;

                                    if ( isProtocol ) {
                                        zoomPoint = this.state.zoomPointProtocol;
                                    }

                                    this.setZoomPoint( zoomPoint + 0.2, isProtocol );
                                }}
                            ></button>
                            <button
                                className="btn-zoom pr"
                                type="button"
                                onClick={() => {
                                    let zoomPoint = this.state.zoomPoint;

                                    if ( isProtocol ) {
                                        zoomPoint = this.state.zoomPointProtocol;
                                    }

                                    this.setZoomPoint( zoomPoint - 0.2, isProtocol );
                                }}
                            ></button>
                        </div>

                    </div>
                );

            }

            if ( formResponse.file.hasOwnProperty('pdf') ) {

                result = (
                    <div className="main-wrapper__report-result">

                        <div className="main-wrapper__report-result-top tr">

                            <ul className="main-wrapper__report-result-list">
                                <li className="main-wrapper__report-result-item ver-top-box fs14">{trans( this.props.b2bTrans, 'b2b.financial_reports.download_title' )}</li>
                                <li className="main-wrapper__report-result-item ver-top-box">
                                    <a
                                        className="btn-download db fs14 sprite-b pr"
                                        href={formResponse.file.pdf.url}
                                        download={formResponse.file.pdf.name}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{trans( this.props.b2bTrans, 'b2b.financial_reports.download_file_title_2' )}</a>
                                </li>
                                <li className="main-wrapper__report-result-item ver-top-box">
                                    <a
                                        className="btn-download db fs14 sprite-b pr btn-download--green"
                                        href={formResponse.file.xlsx.url}
                                        download={formResponse.file.xlsx.name}
                                    >{trans( this.props.b2bTrans, 'b2b.financial_reports.download_file_title_1' )}</a>
                                </li>
                                <li className="main-wrapper__report-result-item main-wrapper__report-result-item--left-border ver-top-box">
                                    <button
                                        className="btn-print fs14 pr sprite-b"
                                        type="button"
                                        onClick={() => window.print()}
                                    >{trans( this.props.b2bTrans, 'b2b.financial_reports.print_title' )}</button>
                                </li>
                            </ul>

                        </div>

                        {table}

                    </div>
                );

            } else if ( formResponse.result.error === null ) {
                result = <p className="empty-message empty-message--warning tc">{trans( this.props.b2bTrans, 'b2b.financial_reports.empty_message' )}</p>;
            }

        } else if ( formResponse !== '' && formResponse.file instanceof Array && formResponse.result.status === 'OK' ) {
            result = <p className="empty-message empty-message--warning tc">{trans( this.props.b2bTrans, 'b2b.financial_reports.empty_message' )}</p>;
        }

        return result;

    }

    showBanStatus( ban, protocol ){

        const data = {
            className: '',
            message: null
        };

        let resultBans = this.state.resultBans;

        if ( protocol ) {
            resultBans = this.state.resultBansProtocol;
        }

        if ( resultBans.hasOwnProperty( ban ) ) {

            if ( typeof resultBans[ban] === 'object' ) {
                data.className = ' main-wrapper__report-ban--error';
                data.message = <p className="main-wrapper__report-ban-error-txt fs12">{resultBans[ban].error.message}</p>;
            } else {
                data.className = ' main-wrapper__report-ban--success sprite-a';
            }

        }

        return data;

    }

    banList(){

        const items = this.banCollection.map(( item, index ) => {

            let statusData = this.showBanStatus( item );

            return (
                <li className="main-wrapper__report-ban-item ver-top-box" key={index}>
                    <div
                        className={'main-wrapper__report-ban fs18 pr' + ( this.state.hasBanItem === item ? ' main-wrapper__report-ban--error' : '' ) +
                                                                        statusData.className}
                        style={ this.state.hasBanItem === item ? { transition: 'border-color 0.15s ease' } : {} }
                    >{item}
                        <button
                            className="main-wrapper__report-ban-remove fs28 pa tc"
                            type="button"
                            onClick={() => {

                                const { resultBans } = this.state;

                                if ( resultBans.hasOwnProperty( item ) ) {
                                    delete resultBans[item];
                                }

                                this.banCollection.splice( this.banCollection.indexOf( item ), 1 );
                                this.setState({
                                    banCount: this.state.banCount - 1,
                                    hasBanLimitAbove: false,
                                    toggleAllBans: this.state.curatorBanCount === this.state.banCount - 1,
                                    curatorBanCountError: false,
                                    curatorBanNotOwnError: false,
                                    resultBans
                                });
                            }}
                        >&times;</button>
                    </div>
                    {statusData && statusData.message}
                </li>
            );

        });

        return (
            <ul className="main-wrapper__report-ban-list">{items}</ul>
        );

    }

    banListProtocol(){

        const items = this.banCollection2.map(( item, index ) => {

            let statusData = this.showBanStatus( item, 'protocol' );

            return (
                <li className="main-wrapper__report-ban-item ver-top-box" key={index}>
                    <div
                        className={'main-wrapper__report-ban fs18 pr' + ( this.state.hasBanItemProtocol === item ? ' main-wrapper__report-ban--error' : '' ) +
                                                                        statusData.className}
                        style={ this.state.hasBanItemProtocol === item ? { transition: 'border-color 0.15s ease' } : {} }
                    >{item}
                        <button
                            className="main-wrapper__report-ban-remove fs28 pa tc"
                            type="button"
                            onClick={() => {

                                const { resultBansProtocol } = this.state;

                                if ( resultBansProtocol.hasOwnProperty( item ) ) {
                                    delete resultBansProtocol[item];
                                }

                                this.banCollection2.splice( this.banCollection2.indexOf( item ), 1 );
                                this.setState({
                                    banCountProtocol: this.state.banCountProtocol - 1,
                                    hasBanLimitAboveProtocol: false,
                                    toggleAllBansProtocol: this.state.curatorBanCountProtocol === this.state.banCountProtocol - 1,
                                    curatorBanCountErrorProtocol: false,
                                    curatorBanNotOwnErrorProtocol: false,
                                    resultBansProtocol
                                });
                            }}
                        >&times;</button>
                    </div>
                    {statusData && statusData.message}
                </li>
            );

        });

        return (
            <ul className="main-wrapper__report-ban-list">{items}</ul>
        );

    }

    addBan( addBanIsAllow ){

        const banField = this.state['ban-field'];

        if ( !addBanIsAllow && this.banCollection.indexOf( banField ) > -1 ) {

            this.setState( { hasBanItem: banField } );
            setTimeout(() => this.setState( { hasBanItem: '' } ), 150);

        } else if ( this.props.curator === 'curator' ) {

            let isBanFromCuratorList = false;

            for ( let i = 0, l = this.state.profileData.data.bans.length; i < l; i++ ) {

                if ( this.state.profileData.data.bans[i]['ban'].toString() === banField ) {
                    isBanFromCuratorList = true;
                }

            }

            if ( !isBanFromCuratorList ) {
                this.setState({ curatorBanNotOwnError: true });
                return;
            } else if ( this.state.curatorBanCount === this.state.banCount ) {
                this.setState({ curatorBanCountError: true });
                return;
            }

        } else if ( !addBanIsAllow && this.state.banCount === this.state.banLimit ) {
            this.setState({ hasBanLimitAbove: true });
        }

        if ( !addBanIsAllow && this.state.banCount < this.state.banLimit && this.banCollection.indexOf( banField ) === -1 ) {

            this.banCollection.push( banField );

            this.setState({
                'ban-field': '',
                banCount: this.state.banCount + 1,
                toggleAllBans: this.state.curatorBanCount === this.state.banCount + 1,
                curatorBanCountError: false,
                curatorBanNotOwnError: false
            });

        }

    }

    addBanProtocol( addBanIsAllow ){

        const banField = this.state['ban-field-protocol'];

        if ( !addBanIsAllow && this.banCollection2.indexOf( banField ) > -1 ) {

            this.setState( { hasBanItemProtocol: banField } );
            setTimeout(() => this.setState( { hasBanItemProtocol: '' } ), 150);

        } else if ( this.props.curator === 'curator' ) {

            let isBanFromCuratorList = false;

            for ( let i = 0, l = this.state.profileData.data.bans.length; i < l; i++ ) {

                if ( this.state.profileData.data.bans[i]['ban'].toString() === banField ) {
                    isBanFromCuratorList = true;
                }

            }

            if ( !isBanFromCuratorList ) {
                this.setState({ curatorBanNotOwnErrorProtocol: true });
                return;
            } else if ( this.state.curatorBanCountProtocol === this.state.banCountProtocol ) {
                this.setState({ curatorBanCountErrorProtocol: true });
                return;
            }

        } else if ( !addBanIsAllow && this.state.banCountProtocol === this.state.banLimitProtocol ) {
            this.setState({ hasBanLimitAboveProtocol: true });
        }

        if ( !addBanIsAllow && this.state.banCountProtocol < this.state.banLimitProtocol && this.banCollection2.indexOf( banField ) === -1 ) {

            this.banCollection2.push( banField );

            this.setState({
                'ban-field-protocol': '',
                banCountProtocol: this.state.banCountProtocol + 1,
                toggleAllBansProtocol: this.state.curatorBanCountProtocol === this.state.banCountProtocol + 1,
                curatorBanCountErrorProtocol: false,
                curatorBanNotOwnErrorProtocol: false
            });

        }

    }

    toggleAllBansBox(){

        if ( this.props.curator === '' || this.state.curatorBanCount === 0 || this.state.curatorBanCount > this.state.banLimit ) {
            return null;
        }

        return (
            <>
                <div className="main-wrapper__report-cell ver-top-box">
                    <input
                        className="form__switcher-checkbox dn"
                        name="check-all-bans"
                        id="check-all-bans"
                        type="checkbox"
                        checked={this.state.toggleAllBans}
                        onChange={() => {

                            let banCount = this.state.banCount;
                            this.banCollection = [];

                            if ( !this.state.toggleAllBans && this.state.profileData !== '' && this.state.profileData.status === 'OK' ) {
                                this.state.profileData.data.bans.map( ({ ban }, index) => {
                                    this.banCollection.push( ban.toString() );
                                    banCount = index + 1;
                                    return ban;
                                });
                            } else {
                                banCount = 0;
                            }

                            this.setState({
                                toggleAllBans: !this.state.toggleAllBans,
                                banCount,
                                curatorBanCountError: false,
                                curatorBanNotOwnError: false,
                                resultBans: {}
                            });
                        }}
                    />
                    <label className="form__switcher db fs18 sprite-a pr select-none" htmlFor="check-all-bans">{trans( this.props.b2bTrans, 'b2b.financial_reports.toggle_all_label' )}</label>
                </div>
            </>
        );

    }

    toggleAllBansBoxProtocol(){

        if ( this.props.curator === '' || this.state.curatorBanCountProtocol === 0 || this.state.curatorBanCountProtocol > this.state.banLimitProtocol ) {
            return null;
        }

        return (
            <>
                <div className="main-wrapper__report-cell ver-top-box">
                    <input
                        className="form__switcher-checkbox dn"
                        name="check-all-bans-protocol"
                        id="check-all-bans-protocol"
                        type="checkbox"
                        checked={this.state.toggleAllBansProtocol}
                        onChange={() => {

                            let banCountProtocol = this.state.banCountProtocol;
                            this.banCollection2 = [];

                            if ( !this.state.toggleAllBansProtocol && this.state.profileData !== '' && this.state.profileData.status === 'OK' ) {
                                this.state.profileData.data.bans.map( ({ ban }, index) => {
                                    this.banCollection2.push( ban.toString() );
                                    banCountProtocol = index + 1;
                                    return ban;
                                });
                            } else {
                                banCountProtocol = 0;
                            }

                            this.setState({
                                toggleAllBansProtocol: !this.state.toggleAllBansProtocol,
                                banCountProtocol,
                                curatorBanCountErrorProtocol: false,
                                curatorBanNotOwnErrorProtocol: false,
                                resultBansProtocol: {}
                            });
                        }}
                    />
                    <label className="form__switcher db fs18 sprite-a pr select-none" htmlFor="check-all-bans-protocol">{trans( this.props.b2bTrans, 'b2b.financial_reports.toggle_all_label' )}</label>
                </div>
            </>
        );

    }

    sendRequestSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        let resultBans = {};

        if ( data && data.hasOwnProperty('error') && data.error.status === 'INVALID_DATA' ) {
            resultBans = data.error.data;
        }

        if ( data && data.hasOwnProperty('file') && (data.file.hasOwnProperty('pdf') || data.file.hasOwnProperty('zip')) ) {

            for ( let i in this.banCollection ) {
                if ( !resultBans.hasOwnProperty(this.banCollection[i]) ) {
                    resultBans[this.banCollection[i]] = this.banCollection[i];
                }
            }

        }

        this.setState({
            buttonDisabled: false,
            formResponse: data,
            resultBans
        }, () => {

            const { formResponse } = this.state;

            if ( formResponse !== '' && formResponse.hasOwnProperty('result') && formResponse.result.status === 'OK' ) {

                if ( formResponse.result.count === 1 ) {
                    setTimeout(() => {
                        const reportResultBox = document.getElementsByClassName('main-wrapper__report-result');
                        if ( reportResultBox.length ) {
                            document.getElementsByClassName('main-wrapper__right-inner')[0].scrollTop = reportResultBox[0].offsetTop;
                        }
                    }, 0);
                } else if ( formResponse.result.count > 1 && formResponse.file.hasOwnProperty('zip') ) {
                    window.location = formResponse.file.zip.url;
                }

            }

        });

    }

    sendRequestSuccessProtocol({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        let resultBansProtocol = {};

        if ( data && data.hasOwnProperty('error') && data.result.hasOwnProperty('error') && data.result.error && data.result.error.status === 'INVALID_DATA' ) {
            resultBansProtocol = data.result.error.data;
        }

        if ( data !== '' && data.hasOwnProperty('file') && (data.file.hasOwnProperty('pdf') || data.file.hasOwnProperty('zip')) ) {

            for ( let i in this.banCollection2 ) {
                if ( !resultBansProtocol.hasOwnProperty(this.banCollection2[i]) ) {
                    resultBansProtocol[this.banCollection2[i]] = this.banCollection2[i];
                }
            }

        }

        this.setState({
            buttonDisabledProtocol: false,
            formResponseProtocol: data,
            resultBansProtocol
        }, () => {

            const { formResponseProtocol } = this.state;

            if ( formResponseProtocol !== '' && formResponseProtocol.hasOwnProperty('result') && formResponseProtocol.result.status === 'OK' ) {

                if ( formResponseProtocol.result.count === 1 ) {
                    setTimeout(() => {
                        const reportResultBox = document.getElementsByClassName('main-wrapper__report-result');
                        if ( reportResultBox.length ) {
                            document.getElementsByClassName('main-wrapper__right-inner')[0].scrollTop = reportResultBox[0].offsetTop;
                        }
                    }, 0);
                } else if ( formResponseProtocol.result.count > 1 && formResponseProtocol.file.hasOwnProperty('zip') ) {
                    window.location = formResponseProtocol.file.zip.url;
                }

            }

        });

    }

    sendRequest(){

        this.setState({
            buttonDisabled: true,
            formResponse: '',
            resultBans: {}
        });

        let date_from = this.state.startMonth,
            date_to = this.state.endMonth;

        if ( date_from ) {
            date_from = doubleNumber( date_from.getMonth()+1 ) + '-' + date_from.getFullYear();
        }

        if ( date_to ) {
            date_to = doubleNumber( date_to.getMonth()+1 ) + '-' + date_to.getFullYear();
        }

        const data = {
            jwt: this.props.getDecryptedToken(),
            reportType: this.state['choose-form'],
            fileType: this.state['file-type-form'],
            date_from,
            date_to
        };

        for ( let i in this.banCollection ) {
            data['ban[' + i + ']'] = this.banCollection[i];
        }

        ApiManager.getRequest(data, '/b2b' + this.props.curator + '/financial-report/get-invoices').then( this.sendRequestSuccess, this.props.errorCallBack );

    }

    sendRequestProtocol(){

        this.setState({
            buttonDisabledProtocol: true,
            formResponseProtocol: '',
            resultBansProtocol: {}
        });

        let date = this.state.startMonthProtocol;

        if ( date ) {
            date = doubleNumber( date.getMonth()+1 ) + '-' + date.getFullYear();
        }

        const data = {
            jwt: this.props.getDecryptedToken(),
            reportType: this.state.selectedOption && this.state.selectedOption.value,
            fileType: this.state['file-type-form-protocol'],
            date
        };

        for ( let i in this.banCollection2 ) {
            data['ban[' + i + ']'] = this.banCollection2[i];
        }

        ApiManager.getRequest(data, '/b2b' + this.props.curator + '/financial-report/get-protocol').then( this.sendRequestSuccessProtocol, this.props.errorCallBack );

    }

    protocolsView( finReport ){

        if ( !finReport ) {
            return null;
        }

        return (
            <div className="main-wrapper__gray-bg">
                <a
                    className="main-wrapper__download fs14 monserrat-medium ver-top-box pr"
                    href={`${config.urlPrefix}template/protocol.xlsx`}
                    download="protocol.xlsx"
                >{trans( this.props.b2bTrans, 'b2b.financial_reports.download_protocols_title' )}</a>
            </div>
        );

    }

    timeline2( defaultLngPrefix ){

        const formResponseProtocol = this.state.formResponseProtocol;
        const minDate = new Date();
        const maxDate = new Date();

        // Set min date
        minDate.setFullYear(minDate.getFullYear() - 1);
        minDate.setMonth( minDate.getMonth()-1 );

        // Set max date
        maxDate.setMonth( maxDate.getMonth()-1 );

        let startDateErrorClass = '',
            startDateErrorBox = '',
            reportTypeErrorClass = '',
            reportTypeErrorBox = '';

        if ( formResponseProtocol  !== '' ) {

            if ( formResponseProtocol.hasOwnProperty('status') && formResponseProtocol.status === 'INVALID_DATA' ) {

                if ( formResponseProtocol.errors.hasOwnProperty('date') ) {
                    startDateErrorClass = ' form-error';
                    startDateErrorBox = (
                        <div className="form-error">
                            <div className="form-error-text form-error-text--top-space fs11">{formResponseProtocol.errors.date}</div>
                        </div>
                    );
                }

                if ( formResponseProtocol.errors.hasOwnProperty('reportType') ) {
                    reportTypeErrorClass = ' form-error';
                    reportTypeErrorBox = (
                        <div className="form-error">
                            <div className="form-error-text form-error-text--top-space fs11">{formResponseProtocol.errors.reportType}</div>
                        </div>
                    );
                }

            }

        }

        return (
            <div className="main-wrapper__report-form-box">
                <div className="main-wrapper__report-item ver-top-box">
                    <div className="main-wrapper__report-label-box">
                        <label className="main-wrapper__report-label fs18">{trans( this.props.b2bTrans, 'b2b.financial_reports.select_label' )}</label>
                    </div>
                    <div className={`form__field-out form__field-out--select-bigger pr${reportTypeErrorClass}`}>
                        <Select
                            options={this.options()}
                            value={this.state.selectedOption}
                            onChange={this.handleSelectChange}
                            placeholder={trans( this.props.b2bTrans, 'b2b.financial_reports.select_default_label' )}
                            noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.financial_reports.select_no_options_message' )}
                        />
                    </div>
                    {reportTypeErrorBox}
                </div>

                <div className="main-wrapper__report-item ver-top-box">
                    <div className="main-wrapper__report-label-box">
                        <label htmlFor="choose-form-date" className="main-wrapper__report-label fs18">{trans( this.props.b2bTrans, 'b2b.financial_reports.date_label' )}</label>
                    </div>

                    <div className={`main-wrapper__sort-form-datepicker pr${startDateErrorClass}`}>
                        <div className="main-wrapper__sort-form-datepicker-current ver-top-box">
                            <div className="react-datepicker-wrapper">
                                <div className="react-datepicker__input-container">
                                    <DatePicker
                                        selected={this.state.startMonthProtocol}
                                        minDate={new Date( minDate )}
                                        maxDate={new Date( maxDate )}
                                        dateFormat="MM.yyyy"
                                        locale={defaultLngPrefix}
                                        onChange={( date ) => this.datepickerSetterProtocol( date, this.state.startMonthProtocol ) }
                                        showMonthYearPicker={true}
                                        placeholderText={trans( this.props.b2bTrans, 'b2b.financial_reports.start_date_placeholder' )}
                                        ref={(c) => this.startDatepickerRef2 = c}
                                    />

                                </div>
                            </div>
                        </div>
                        <button
                            className="main-wrapper__sort-form-datepicker-btn sprite pa"
                            type="button"
                            onClick={() => this.startDatepickerRef2.setFocus()}
                        ></button>
                    </div>
                    {startDateErrorBox}
                </div>

            </div>
        );

    }

    timeline( defaultLngPrefix ){

        const formResponse = this.state.formResponse;

        let startDateErrorBox = '',
            endDateErrorBox = '';

        if ( formResponse  !== '' ) {

            if ( formResponse.hasOwnProperty('status') && formResponse.status === 'INVALID_DATA' ) {

                if ( formResponse.errors.hasOwnProperty('date_from') ) {
                    startDateErrorBox = (
                        <div className="form-error">
                            <div className="form-error-text form-error-text--top-space fs11">{formResponse.errors.date_from}</div>
                        </div>
                    );
                }

                if ( formResponse.errors.hasOwnProperty('date_to') ) {
                    endDateErrorBox = (
                        <div className="form-error ver-top-box">
                            <div className="form-error-text form-error-text--top-space fs11">{formResponse.errors.date_to}</div>
                        </div>
                    );
                }

            }

        }

        return (
            <div className="main-wrapper__report-form-box">
                <div className="main-wrapper__report-label-box">
                    <label htmlFor="choose-form" className="main-wrapper__report-label fs18">{trans( this.props.b2bTrans, 'b2b.financial_reports.date_label' )}</label>
                </div>

                <div className="main-wrapper__sort-form-datepicker main-wrapper__sort-form-datepicker--double pr">
                    <div className="main-wrapper__sort-form-datepicker-current ver-top-box">
                        <div className="react-datepicker-wrapper">
                            <div className="react-datepicker__input-container">

                                <DatePicker
                                    selected={this.state.startMonth}
                                    dateFormat="MM.yyyy"
                                    locale={defaultLngPrefix}
                                    onChange={( date ) => this.datepickerSetter( date, '', this.state.endMonth ) }
                                    showMonthYearPicker={true}
                                    placeholderText={trans( this.props.b2bTrans, 'b2b.financial_reports.start_date_placeholder' )}
                                    ref={(c) => this.startDatepickerRef = c}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="main-wrapper__sort-form-datepicker-sep ver-top-box"></div>
                    <div className="main-wrapper__sort-form-datepicker-current ver-top-box">
                        <div className="react-datepicker-wrapper">
                            <div className={`react-datepicker__input-container`}>

                                <DatePicker
                                    selected={this.state.endMonth}
                                    dateFormat="MM.yyyy"
                                    locale={defaultLngPrefix}
                                    onChange={( date ) => this.datepickerSetter( date, this.state.startMonth, '' ) }
                                    showMonthYearPicker={true}
                                    placeholderText={trans( this.props.b2bTrans, 'b2b.financial_reports.end_date_placeholder' )}
                                />

                            </div>
                        </div>
                    </div>
                    <button
                        className="main-wrapper__sort-form-datepicker-btn sprite pa"
                        type="button"
                        onClick={() => this.startDatepickerRef.setFocus()}
                    ></button>
                </div>
                {startDateErrorBox}
                {endDateErrorBox}

            </div>
        );

    }

    submitButton( isProtocol ){

        let sendRequest = this.sendRequest,
            isDisabled = ( this.state.buttonDisabled || this.banCollection.length === 0 ),
            isDisabledClass = this.state.buttonDisabled;

        if ( isProtocol ) {
            sendRequest = this.sendRequestProtocol;
            isDisabled = ( this.state.buttonDisabledProtocol || this.banCollection2.length === 0 );
            isDisabledClass = this.state.buttonDisabledProtocol;
        }
        
        return (
            <div className="main-wrapper__report-form-btn-box">
                <button
                    className={`btn btn--yellow fs18 monserrat-medium${isDisabledClass ? ' btn--loading' : ''}`}
                    type="submit"
                    disabled={isDisabled}
                    onClick={() => sendRequest()}
                >{trans( this.props.b2bTrans, 'b2b.financial_reports.form_btn_title' )}</button>
            </div>
        );

    }

    banMethod( isProtocol ){

        let curatorBanCountErrorClass = '',
            curatorBanCountErrorBox = '',
            banField = this.state['ban-field'],
            curatorBanCountError = this.state.curatorBanCountError,
            curatorBanNotOwnError = this.state.curatorBanNotOwnError,
            fieldName = 'ban-field',
            hasBanLimitAbove = this.state.hasBanLimitAbove;

        if ( isProtocol ) {
            banField = this.state['ban-field-protocol'];
            curatorBanCountError = this.state['curatorBanCountErrorProtocol'];
            curatorBanNotOwnError = this.state['curatorBanNotOwnErrorProtocol'];
            fieldName = 'ban-field-protocol';
            hasBanLimitAbove = this.state['hasBanLimitAboveProtocol'];
        }

        const addBanIsAllow = banField.length < 9;

        if ( curatorBanCountError || curatorBanNotOwnError ) {
            curatorBanCountErrorClass = ' form-error';
            curatorBanCountErrorBox = <div className="form-error-text form-error-text--top-space fs11">{trans( this.props.b2bTrans, 'b2b.financial_reports.' + ( curatorBanCountError ? 'curator_ban_limit_error' : 'curator_ban_not_own_error' ) )}</div>;
        }

        return (
            <div className="main-wrapper__report-form-box main-wrapper__report-form-box--mb35">
                <div className="main-wrapper__report-label-box">
                    <label htmlFor="ban-field" className="main-wrapper__report-label fs18">{trans( this.props.b2bTrans, 'b2b.financial_reports.ban_label' )}</label>
                </div>

                <div
                    className={`main-wrapper__report-field-box ver-top-box${curatorBanCountErrorClass}`}
                >
                    <input
                        className="main-wrapper__report-field fs14"
                        name={fieldName}
                        id={fieldName}
                        type="text"
                        value={banField}
                        data-filter="numberOnly"
                        maxLength={9}
                        onChange={this.handleChange}
                        onKeyDown={( event ) => {
                            if ( event.keyCode === 13 ) {
                                if ( !addBanIsAllow ) {
                                    if ( isProtocol ) {
                                        this.addBanProtocol( addBanIsAllow );
                                    } else {
                                        this.addBan( addBanIsAllow );
                                    }
                                }

                                event.preventDefault();
                            }
                        }}
                    />
                    {curatorBanCountErrorBox}
                </div>
                <button
                    className="main-wrapper__report-add-btn btn btn--yellow fs36 ver-top-box"
                    type="button"
                    disabled={addBanIsAllow}
                    onClick={() => {

                        if ( isProtocol ) {
                            this.addBanProtocol( addBanIsAllow );
                        } else {
                            this.addBan( addBanIsAllow );
                        }

                    }}
                >+</button>
                {
                    hasBanLimitAbove ?
                        <div
                            className="main-wrapper__report-cell main-wrapper__report-cell--warn ver-top-box fs18"
                        >{trans(this.props.b2bTrans, 'b2b.financial_reports.limit_text')}</div> :
                        null
                }

                {
                    isProtocol
                        ? <>
                            {this.toggleAllBansBoxProtocol()}
                            {this.banListProtocol()}
                          </>
                        : <>
                            {this.toggleAllBansBox()}
                            {this.banList()}
                          </>
                }
            </div>
        );

    }

    fileTypes( isProtocol ){

        let banCollection = this.banCollection,
            fieldName = 'file-type-form',
            fieldIdPdf = 'file-pdf-form',
            fieldIdXlsx = 'file-xlsx-form';

        if ( isProtocol ) {
            banCollection = this.banCollection2;
            fieldName = 'file-type-form-protocol';
            fieldIdPdf = 'file-pdf-form-protocol';
            fieldIdXlsx = 'file-xlsx-form-protocol';
        }

        return (
            banCollection.length > 1 ?
                <div className="main-wrapper__report-form-box main-wrapper__report-form-box--mb12">
                    <div className="main-wrapper__report-label-box">
                        <label htmlFor="file-pdf-form" className="main-wrapper__report-label fs18">{trans( this.props.b2bTrans, 'b2b.financial_reports.download_label' )}</label>
                    </div>

                    <div className="main-wrapper__report-type-wrap main-wrapper__report-type-wrap--standard">
                        <div className="main-wrapper__report-type">
                            <input
                                className="main-wrapper__report-input dn"
                                type="radio"
                                name={fieldName}
                                id={fieldIdPdf}
                                value="pdf"
                                checked={this.state[fieldName] === 'pdf'}
                                onChange={this.handleChange}
                            />
                            <label
                                htmlFor={fieldIdPdf}
                                className="main-wrapper__report-type-label db fs14 pr"
                            >{trans( this.props.b2bTrans, 'b2b.financial_reports.file_type_1' )}</label>
                        </div>
                        <div className="main-wrapper__report-type">
                            <input
                                className="main-wrapper__report-input dn"
                                type="radio"
                                name={fieldName}
                                id={fieldIdXlsx}
                                value="xlsx"
                                checked={this.state[fieldName] === 'xlsx'}
                                onChange={this.handleChange}
                            />
                            <label
                                htmlFor={fieldIdXlsx}
                                className="main-wrapper__report-type-label main-wrapper__report-type-label--green db fs14 pr"
                            >{trans( this.props.b2bTrans, 'b2b.financial_reports.file_type_2' )}</label>
                        </div>
                    </div>

                </div> : null
        );

    }

    render(){

        const finReport = this.state['choose-form'] !== 'getInvoices';
        const defaultLngPrefix = localStorageGetItem('defaultLngPrefix');

        if ( defaultLngPrefix === 'ru' ) {
            registerLocale('ru', ru);
        } else if ( defaultLngPrefix === 'hy' ) {
            registerLocale('hy', hy);
        }

        let errorBox = '',
            formResponse = this.state.formResponse;

        if ( finReport ) {
            formResponse = this.state.formResponseProtocol;
        }

        if ( formResponse  !== '') {

            if ( formResponse.hasOwnProperty('status') && (formResponse.status === 'ERROR' || formResponse.status === 'NOT_FOUND' || formResponse.status === 'APP_ERROR') ) {

                errorBox = (
                    <div>
                        <div className="ver-top-box">
                            <FormMiddlewareError message={formResponse.message} />
                        </div>
                    </div>
                );

            }

        }

        return(
            <div className="main-wrapper__right-inner scroller-block scroller-block--smooth pr">

                <div className="main-wrapper__right-content">

                    <h2 className={`main-wrapper__title main-wrapper__title--with-border fb fs20${ finReport ? ' mb-none' : '' }`}>{trans( this.props.b2bTrans, 'b2b.financial_reports.inner_title' )}</h2>

                    {this.protocolsView( finReport )}

                    <form className="main-wrapper__report-form" action="#" method="post" onSubmit={( event ) => {
                        event.preventDefault();
                    }}>
                        <div className="main-wrapper__report-form-box main-wrapper__report-form-box--mb12">
                            <div className="main-wrapper__report-label-box">
                                <label htmlFor="choose-form" className="main-wrapper__report-label fs18">{trans( this.props.b2bTrans, 'b2b.financial_reports.choose_form_label' )}</label>
                            </div>

                            <div className="main-wrapper__report-type-wrap">
                                <div className="main-wrapper__report-inner ver-top-box">
                                    <div className="main-wrapper__report-type ver-top-box">
                                        <input
                                            className="main-wrapper__report-input dn"
                                            type="radio"
                                            name="choose-form"
                                            id="choose-form"
                                            checked={this.state['choose-form'] === "getInvoices"}
                                            value="getInvoices"
                                            onChange={this.handleChange}
                                        />
                                        <label htmlFor="choose-form" className="main-wrapper__report-type-label db fs14 pr">
                                            <span className="main-wrapper__report-doc-icon db pa"></span>{trans( this.props.b2bTrans, 'b2b.financial_reports.act_label' )}
                                        </label>
                                    </div>
                                    {
                                        this.props.curator === ''
                                            ? <div className="main-wrapper__report-type ver-top-box">
                                                <input
                                                    className="main-wrapper__report-input dn"
                                                    type="radio"
                                                    name="choose-form"
                                                    id="choose-form-1"
                                                    checked={this.state['choose-form'] === "getProtocols"}
                                                    value="getProtocols"
                                                    onChange={this.handleChange}
                                                />
                                                <label htmlFor="choose-form-1" className="main-wrapper__report-type-label db fs14 pr">
                                                    <span className="main-wrapper__report-doc-icon db pa"></span>{trans( this.props.b2bTrans, 'b2b.financial_reports.protocol_label' )}
                                                </label>
                                            </div> : null
                                    }
                                </div>
                            </div>

                        </div>

                        { finReport ? this.timeline2( defaultLngPrefix ) : this.timeline( defaultLngPrefix ) }
                        { this.banMethod( finReport ) }
                        { this.fileTypes( finReport ) }
                        {errorBox}
                        { this.submitButton( finReport ) }

                        {this.resultTable( finReport )}

                    </form>

                </div>

            </div>
        );

    }

}

export default B2bFinancialReports;
